import { yupResolver } from "@hookform/resolvers/yup";
import { Modal, Button } from "antd";
import { banDriverByIdApi } from "api/driver";
import LabeledInput from "components/Form/LabeledInput";
import WarningIcon from "components/Icons/WarningIcon";
import { useNotificationContext } from "contexts/NotificationContext";
import { IBanDriver, IDriver } from "models/driver";
import { useState } from "react";
import { useForm } from "react-hook-form";
import banDriverValidator from "validators/banDriver.validator";

interface IProp {
  open: boolean;
  driver: IDriver;
  handleClose: () => void;
  reload: () => void;
}

export default function BanModal({ open, driver, handleClose, reload }: IProp) {
  const [loading, setLoading] = useState<boolean>(false);
  const { showError, showSuccess } = useNotificationContext();
  const { control, handleSubmit } = useForm<IBanDriver>({
    resolver: yupResolver(banDriverValidator),
  });

  const onSubmit = async (input: IBanDriver) => {
    setLoading(true);
    const { data, error } = await banDriverByIdApi(driver.id, input);
    if (data) {
      showSuccess("Driver banned successfully");
      reload();
    } else showError(error!.message);
    setLoading(false);
    handleClose();
  };

  return (
    <Modal open={open} title={null} footer={null} closeIcon={null} centered>
      <div className="w-full text-center">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="w-full text-orange-400 text-9xl flex justify-center my-6">
            <WarningIcon />
          </div>
          <h3 className="text-3xl font-semibold my-4">Are you sure?</h3>
          <p
            className="font-normal text-base"
            style={{ color: "rgba(0,0,0,.64)" }}
          >
            You're about to ban {driver.first_name} {driver.last_name}
          </p>
          <div className="w-full mt-2 text-start">
            <LabeledInput
              name="reason"
              type="text"
              label="Reason for banning"
              placeholder="Enter reason"
              control={control}
            />
          </div>
          <div className="w-full flex mt-7 items-center justify-end gap-x-3">
            <Button onClick={handleClose}>Cancel</Button>
            <Button loading={loading} type="primary" danger htmlType="submit">
              Ban
            </Button>
          </div>
        </form>
      </div>
    </Modal>
  );
}
